import { render, staticRenderFns } from "./FilesBlock.vue?vue&type=template&id=dd98e85a"
import script from "./FilesBlock.vue?vue&type=script&lang=js"
export * from "./FilesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports